<div class="content">
  <div class="crop-field-container">
    <app-crop-field-info
      (plantDateChange)="onPlantDateChange($event)"
      (cropVarietyChange)="onCropVarietyChange($event)"
      (selectedCropFieldIdChange)="onCropFieldChange($event)"
      [availableVarieties]="availableVarieties()"
      [varietiesLoadFailed]="varietiesLoadFailed()"
      [isSaving]="isSaving()"
      [bemDataResponse]="bemData$ | async"
      [nutrientCalculations]="(calculations$ | async)!"
    />
    <div class="crop-soil-analysis-block-wrapper">
      <app-crop-soil-analysis-block
        [cropSoilAnalysisData$]="cropSoilAnalysisData$"
        [isSeedpotato]="(isSeedpotato$ | async) ?? false"
      />
    </div>
    <app-nutrient-advice [nutrientAdviceData$]="nutrientAdviceData$" />
    <app-trendline-graphs [trendLineData$]="trendLineData$" />
    <app-footer />
  </div>
</div>
